<ng-template #content let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">{{modalTitle}}</h4>
    </div>
    <div class="modal-body">
        {{modalDescription}}
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-danger"
            (click)="modal.close(false)">{{'GENERAL.no' | translate}}</button>
        <button type="button" class="btn btn-outline-success"
            (click)="modal.close(true)">{{'GENERAL.yes' | translate}}</button>
    </div>
</ng-template>